import React, { useState, useEffect } from "react";
import Loader from "../../components/Loader";
import PageTitle from "../../components/PageTitle";
import PageBody from "../../components/PageBody";
import Content from "../../layouts/Content";
import { Col, Row } from "reactstrap";
import NavTabNutri from "../../components/NavTabNutri";
import InDepthReport from "./components/InDepthReport";

const configPage = {
  titlePage: "Báo cáo tổng quan",
  url: "https://binutri.f99.link/public/dashboard/ecf5a951-e1d0-44fe-a45b-2e716df42bb3?start_date=2023-09-20&end_date=2023-09-20&seller=C%E1%BB%99ng%20ngh%E1%BB%87%20Test&c%25C6%25A1_s%25E1%25BB%259F=Ph%C3%B2ng%20kh%C3%A1m%20H%C3%A0ng%20B%C3%B4ng",
};

interface Props {
  history: any;
  location: any;
  match: any;
}

interface typeUserInfo {
  id?: string;
  name: string;
  shortName: string;
}

const TABS: any = [
  {
    value: 1,
    label: "Báo cáo tổng quan",
  },
  {
    value: 2,
    label: "Báo cáo chuyên môn",
  },
];

const OverviewReport: React.FC<Props> = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const [tabActive, setTabActive] = useState(1);

  const loadContentPage = () => {
    switch (tabActive) {
      case 1: {
        return (
          <Content>
            <iframe
              style={{
                width: "100%",
                minHeight: "calc(100vh - 165px)",
                border: "none",
              }}
              src={`${configPage.url}`}
            ></iframe>
          </Content>
        );
      }
      case 2: {
        return (
          <InDepthReport />
        );
      }
    }
  };

  useEffect(() => {
    document.title = configPage.titlePage;
  }, []);

  return (
    <React.Fragment>
      <PageTitle
        breadCrumbItems={[{ label: "Báo cáo tổng quan", active: true }]}
        title={"Báo cáo tổng quan"}
      />
      <Row>
        <Col md={10}>
          <div className="mb-3">
            <NavTabNutri
              {...props}
              tabList={TABS}
              setTab={(tab: any) => setTabActive(tab)}
              tab={tabActive || 0}
              classes="mt-3 mb-0 nav-tab-full"
            />
          </div>
        </Col>
      </Row>
      {loadContentPage()}
      {loading && <Loader />}
    </React.Fragment>
  );
};
export default OverviewReport;
